import jsPDF from "jspdf";
import { QUESTIONS } from "@/lib/api";

export function bandRGB(band) {
  if (band === "Strong" || band === "Standout") return [45, 106, 79];
  if (band === "Getting there") return [217, 119, 6];
  return [200, 85, 61];
}

export function buildPdf(data) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const margin = 48;
  const maxW = pageW - margin * 2;
  let y = margin;

  const ensure = (h) => {
    if (y + h > pageH - margin) {
      doc.addPage();
      y = margin;
    }
  };
  const write = (text, size, color, gap = 6, style = "normal") => {
    doc.setFont("helvetica", style);
    doc.setFontSize(size);
    doc.setTextColor(color[0], color[1], color[2]);
    const lines = doc.splitTextToSize(text, maxW);
    lines.forEach((ln) => {
      ensure(size + 4);
      doc.text(ln, margin, y);
      y += size + 4;
    });
    y += gap;
  };

  write("StatementMate — UCAS feedback", 18, [17, 42, 34], 4, "bold");
  write(
    `Course: ${data.course}   |   Country: ${data.country}${
      data.qualification_type ? `   |   Qualification: ${data.qualification_type}` : ""
    }`,
    10,
    [81, 96, 88],
    10
  );
  write(`Overall: ${data.overall_band}`, 14, bandRGB(data.overall_band), 2, "bold");
  write(data.verdict, 11, [44, 59, 54], 14);

  data.questions.forEach((q, i) => {
    write(`Question ${i + 1}: ${QUESTIONS[i]}`, 12, [17, 42, 34], 2, "bold");
    if (q.feedback) {
      write(`Band: ${q.feedback.band}`, 11, bandRGB(q.feedback.band), 6, "bold");
      write("What's working", 10, [45, 106, 79], 2, "bold");
      q.feedback.working.forEach((w) => write("•  " + w, 10, [44, 59, 54], 2));
      y += 2;
      write("How to improve", 10, [200, 85, 61], 2, "bold");
      q.feedback.improvements.forEach((w) => write("•  " + w, 10, [44, 59, 54], 2));
    }
    y += 10;
  });

  if (Array.isArray(data.thinking_questions) && data.thinking_questions.length) {
    write("Questions to push your thinking", 13, [17, 42, 34], 2, "bold");
    write("Answer these honestly and you'll find stronger material for your statement.", 9, [81, 96, 88], 6);
    data.thinking_questions.forEach((q, i) => write(`${i + 1}.  ${q}`, 10, [44, 59, 54], 3));
    y += 10;
  }

  write(
    "This feedback assesses your statement — it never writes it for you. Your statement was not stored.",
    8,
    [138, 154, 146],
    0
  );
  return doc;
}
